<template>
  <div class="hvh-flex wrap charts">
    <div class="hvh-flex col-12 p-0">
      <CohortMap class="rectangle" :cohort="cohort" :value="value.area" @input="filterChanged({ area: $event })" />
    </div>
    <div class="hvh-flex col-12 col-lg-6 p-0">
      <CohortGender class="rectangle" :cohort="cohort" :value="value.genders" @input="filterChanged({ genders: $event })" />
    </div>
    <div class="hvh-flex col-12 col-lg-6 p-0">
      <CohortInsurance class="rectangle" :cohort="cohort" :value="value.insurances" @input="filterChanged({ insurances: $event })" />
    </div>
    <div class="hvh-flex col-12 col-lg-6 p-0">
      <CohortAge class="rectangle" :cohort="cohort" :value="value.ages" @input="filterChanged({ ages: $event })" />
    </div>
    <div class="hvh-flex col-12 col-lg-6 p-0">
      <CohortYearly class="rectangle" :cohort="cohort" :value="value.years" @input="filterChanged({ years: $event })" />
    </div>
  </div>
</template>

<script>
import { customNumberFormat, mergeFilters } from '../../../../libraries/common'
import CohortMap from '../../../../components/analytics/cohorts/charts/CohortMap.vue';
import CohortGender from '../../../../components/analytics/cohorts/charts/CohortGender.vue';
import CohortInsurance from '../../../../components/analytics/cohorts/charts/CohortInsurance.vue';
import CohortAge from '../../../../components/analytics/cohorts/charts/CohortAge.vue';
import CohortYearly from '../../../../components/analytics/cohorts/charts/CohortYearly.vue';
export default {
  title: 'Cohort - Patient Demographic',
  components: { CohortMap, CohortGender, CohortInsurance, CohortAge, CohortYearly },
  props: ['cohort', 'value'],
  methods: {
    mergeFilter(obj) {
      return mergeFilters(this.value, { ...(obj || {}) });
    },
    filterChanged(obj) {
      this.$emit('input', {
        ...this.value,
        ...obj,
      });
    },
    customNumberFormat,
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCohortPatientDemographic'] = this;
  },
}
</script>

<style lang="scss" scoped>
.charts {
  padding: 20px;
  .rectangle {
    display: flex;
    padding: 12px;
    margin: 20px 20px;
    flex-grow: 1;
    max-width: calc(100% - 40px);
    box-sizing: border-box;
    border: 1px solid #c6e6e5;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 1px rgba(6, 10, 36, 0.05);
  }
}
</style>